import { Activity, Cable, Code2, Monitor, Network, Package, Printer, ShieldCheck } from "lucide-react";

export const images = {
  hero: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NjAzMjd8MHwxfHNlYXJjaHwxfHxjeWJlciUyMHNlY3VyaXR5JTIwbmV0d29yayUyMGhhcmR3YXJlJTIwZ2xvd2luZyUyMGJsdWV8ZW58MHx8fHwxNzg3OTEyMTgwfDA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1710132819209-f4d38bf5532d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB0ZWNoJTIwb2ZmaWNlJTIwZHViYWklMjB0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3ODc5MTIxODB8MA&ixlib=rb-4.1.0&q=85",
  services: "https://images.unsplash.com/photo-1680992046626-418f7e910589?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxzZXJ2ZXIlMjByb29tJTIwZGF0YWNlbnRlciUyMHRlY2hub2xvZ3klMjBlbmdpbmVlcnxlbnwwfHx8fDE3ODc5MTIxNzJ8MA&ixlib=rb-4.1.0&q=85",
  network: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NjAzMjd8MHwxfHNlYXJjaHwzfHxjeWJlciUyMHNlY3VyaXR5JTIwbmV0d29yayUyMGhhcmR3YXJlJTIwZ2xvd2luZyUyMGJsdWV8ZW58MHx8fHwxNzg3OTEyMTgwfDA&ixlib=rb-4.1.0&q=85",
  skyline: "https://images.unsplash.com/flagged/photo-1559717865-a99cac1c95d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxkdWJhaSUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZSUyMHNreWxpbmUlMjBjb3Jwb3JhdGV8ZW58MHx8fHwxNzg3OTEyMTcyfDA&ixlib=rb-4.1.0&q=85",
};

export const services = [
  {
    id: "hardware",
    number: "01",
    title: "IT Hardware Solutions",
    short: "The dependable endpoint layer",
    intro: "Equip every role with the right performance, reliability and lifecycle support — from a single executive workstation to a complete enterprise fleet.",
    items: ["Business Laptops", "Desktop Computers", "All-in-One PCs", "Professional Monitors", "Engineering Workstations", "Enterprise Servers", "Data Storage Solutions"],
    brands: ["HP", "Dell", "Lenovo", "Asus", "Acer", "Microsoft Surface"],
    Icon: Monitor,
  },
  {
    id: "printing",
    number: "02",
    title: "Printing Solutions",
    short: "Output that keeps work moving",
    intro: "Select and deploy print environments that suit your volume, security and document workflow without adding operational drag.",
    items: ["Laser Printers", "Inkjet Printers", "MFPs", "Production Printers", "Large Format Plotters", "Document Scanners"],
    brands: ["HP", "Canon", "Epson", "Brother", "Kyocera", "Ricoh", "Xerox"],
    Icon: Printer,
  },
  {
    id: "consumables",
    number: "03",
    title: "Toners & Printing Consumables",
    short: "The supplies behind every page",
    intro: "Keep your print fleet consistent with dependable consumables, clear sourcing and the right maintenance cadence for each device.",
    items: ["Original Toners", "Ink Cartridges", "Imaging Drums", "Maintenance Kits"],
    brands: ["HP", "Canon", "Epson", "Brother", "Kyocera", "Ricoh"],
    Icon: Package,
  },
  {
    id: "managed-print",
    number: "04",
    title: "Copier Rental & Managed Print Services",
    short: "Flexible capacity, measured simply",
    intro: "Bring predictable access and accountable oversight to everyday printing with rental options and managed print support.",
    items: ["A3/A4 Copier Rental", "Color Copier Rental", "Managed Print Services"],
    brands: ["Canon", "Ricoh", "Xerox", "Kyocera", "Konica Minolta"],
    Icon: Activity,
  },
  {
    id: "networking",
    number: "05",
    title: "Networking Solutions",
    short: "The connective tissue of the business",
    intro: "Build a stable, secure network foundation that helps people, systems and sites communicate without friction.",
    items: ["Switch Installation & Configuration", "Router Setup & Management", "Enterprise Wi-Fi", "Server Networking", "Firewall Deployment & Security"],
    brands: ["Cisco", "Ubiquiti", "TP-Link", "D-Link", "MikroTik"],
    Icon: Network,
  },
  {
    id: "cabling",
    number: "06",
    title: "Structured Cabling Solutions",
    short: "Infrastructure that disappears into the walls",
    intro: "Make every connection intentional with structured cabling designed for clean expansion, easier troubleshooting and lasting performance.",
    items: ["Cat6/Cat6A Cabling", "Fiber Optic Cabling", "Data Point Installation", "Server Room Infrastructure Setup", "Network Rack Installation"],
    brands: ["CommScope", "Panduit", "Legrand", "Corning"],
    Icon: Cable,
  },
  {
    id: "software",
    number: "07",
    title: "Software Solutions",
    short: "A more productive digital workspace",
    intro: "Connect teams to the licensing, security and productivity tools that help your business operate with confidence.",
    items: ["Microsoft 365", "Windows Licensing", "Antivirus & Endpoint Security", "Data Backup & Recovery", "ERP Applications", "Business Productivity Software"],
    brands: ["Microsoft", "ESET", "Bitdefender", "Acronis", "Sage"],
    Icon: Code2,
  },
];

export const manifesto = [
  { number: "01", title: "Listen before we configure", text: "Every useful system begins with the way your people actually work. We map the friction first." },
  { number: "02", title: "Specify with clarity", text: "Good technology decisions are easy to explain. We turn options, trade-offs and scope into a clear path." },
  { number: "03", title: "Build for the next request", text: "A solution should be ready for your next team, location or deadline — not only today's brief." },
  { number: "04", title: "Stay accountable after install", text: "The handover is a beginning. We keep the operating picture understandable as your business moves." },
];

export const industries = [
  { id: "corporate-offices", title: "Corporate Offices", text: "Reliable workspaces, secure connectivity and productive collaboration for growing teams." },
  { id: "construction-companies", title: "Construction Companies", text: "Site-ready hardware, field connectivity and documentation workflows that keep projects aligned." },
  { id: "schools-universities", title: "Schools & Universities", text: "Manageable learning environments with the right blend of printing, devices, software and network access." },
  { id: "healthcare-organizations", title: "Healthcare Organizations", text: "Careful infrastructure planning for sensitive information, uptime and clear access controls." },
  { id: "retail-businesses", title: "Retail Businesses", text: "Point-of-sale support, inventory connectivity and dependable print operations across every shift." },
  { id: "logistics-transportation", title: "Logistics & Transportation", text: "Connected operations for warehouses, fleets and teams working against the clock." },
  { id: "government-organizations", title: "Government Organizations", text: "Structured, transparent technology procurement and dependable infrastructure for public services." },
  { id: "small-medium-enterprises", title: "Small & Medium Enterprises", text: "Practical technology choices that give ambitious teams enterprise-level confidence without excess." },
];

export const partners = ["HP", "Dell", "Lenovo", "Cisco", "Canon", "Epson", "Microsoft", "Xerox", "Ubiquiti", "Asus"];
